import request from '@/utils/request'
import util from '@/utils/util'
import { ElMessage, ElLoading } from "element-plus/lib/components"

var kaung = {
  path: '',
  _store: null,
  init(path) {
    this.path = '/' + path;
    return this;
  },
  fetch(options) {
    options.method = options.method || 'post';
    return request(options);
  },
  /**
   * 通用分页请求方法
   * @param {*} params 
   * @returns 
   */
  search(params) {
    return request({
      url: params.url || (this.path + '/Search'),
      method: 'post',
      data: params
    });
  },
  /**
   * 通用下载方法
   * @param {*} params 
   * @returns 
   */
  export(params) {
    return request({
      url: this.path + '/Export',
      method: 'post',
      data: params
    });
  },

  getone(id) {
    return request({
      url: this.path + '/' + id,
      method: 'get'
    });
  },

  getid() {
    return request({
      url: this.path + '/PrevID',
      method: 'get'
    });
  },

  /**
   * 新增或保存数据
   * @param {*} params 
   * @returns 
   */
  submit(params) {
    return request({
      url: this.path + '/' + (params.id || ''),
      method: params.id ? 'put' : 'post',
      data: params.data
    });
  },
  post(params) {
    return request({
      url: params.url || params.path || this.path,
      method: params.method || 'post',
      data: params.data
    });
  },

  /**
   * 通用删除方法
   * @param {*} id 
   * @returns 
   */
  delete(id) {
    return request({
      url: this.path + '/' + (id || ''),
      method: 'delete'
    });
  },

  transfer(params) {
    return request({
      url: '/Common/Transfer',
      method: 'post',
      data: params
    })
  },

  template(columns) {
    return request({
      url: '/Common/Template',
      method: 'post',
      data: columns
    });
  },

  companys() {
    return request({
      url: '/BaseCompany/Tree?v=' + util.getVersion(),
      method: 'get',
      cache: (60 * 60 * 24 * 5)
    }).then((res) => {
      return res.code === 200 ? res.data : null;
    });
  },

  /**
   * 根据 WebSetting.ShowOrgFilters 初始化公司列表和公司ID。
   * - 显示模式：加载公司列表，companyId 设为当前用户所属公司
   * - 隐藏模式：companys 设为空数组，companyId 设为特殊值 '*'（后端识别后不过滤公司）
   * @param {object} target Vue 组件实例（this）
   * @param {Function} [callback] 初始化完成后的回调函数，在组件实例上调用
   * @param {object} [opts] 可选配置  {companysKey, companyIdKey}
   */
  initCompanys(target, callback, opts) {
    const companysKey = (opts && opts.companysKey) || 'companys';
    const companyIdKey = (opts && opts.companyIdKey) || 'companyId';
    const webSetting = this._store?.getters.getWebSetting;

    // webSetting 未加载时推迟执行，等 Vuex 中的值就绪后再初始化
    if (!webSetting) {
      const unwatch = this._store.watch(
        (state, getters) => getters.getWebSetting,
        (val) => { if (val) { unwatch(); this.initCompanys(target, callback, opts); } }
      );
      return Promise.resolve(null);
    }

    const showSelector = webSetting.showOrgFilters !== false;

    if (showSelector) {
      return this.companys().then((res) => {
        target[companysKey] = res || [];
        target[companyIdKey] = target.$store?.getters?.getUserInfo?.companyID || '';
        if (callback) callback.call(target);
        return res;
      });
    } else {
      target[companysKey] = [];
      target[companyIdKey] = '*';
      if (callback) callback.call(target);
      return Promise.resolve(null);
    }
  },
  departments(companyId) {
    return request({
      url: '/BaseDepartment/Tree?CompanyId=' + companyId + '&v=' + util.getVersion(),
      method: 'get',
      cache: (60 * 60 * 24 * 5)
    }).then((res) => {
      return res.code === 200 ? res.data : null;
    });
  },
  dictionary(category, code) {
    return request({
      url: '/BaseDict/List?v=' + util.getVersion(),
      params: {
        category: category || '',
        code: code || ''
      },
      method: 'get',
      cache: 60 * 60 * 24 * 7 //7天的缓存
    }).then((res) => {
      var options = [];
      res.data.forEach(function (item) {
        options.push({
          "name": item.name,
          "value": item.value,
          "code": item.code,
          "category": item.category,
          "attribute": item.attribute,
          "id": item.id
        });
      });
      return options;
    });
  },
  // billcode() {
  //   return request({
  //     url: this.path + '/BillCode',
  //     method: 'get'
  //   });
  // },

  message(options) {
    options = options || {};
    if (typeof options === 'string') {
      options = { message: options };
    }
    options.type = options.type || 'info';
    return ElMessage(options);
  },
  success(message) {
    return ElMessage({ message: message, type: 'success' });
  },

  error(message) {
    return ElMessage({ message: message, type: 'error' });
  },

  pushlogs(data) {
    let bizData = {
      ...{ url: window.location.href, displayName: "dashboard", controler: "", body: "", result: "" },
      ...data,
    };
    return request({
      url: '/SysApiLog/',
      method: 'post',
      data: bizData
    }).then((res) => {
      console.log(bizData, res)
    });
  }
};

export default kaung
